import { render, staticRenderFns } from "./MedicineItem.vue?vue&type=template&id=4cba47e8&scoped=true&"
import script from "./MedicineItem.vue?vue&type=script&lang=js&"
export * from "./MedicineItem.vue?vue&type=script&lang=js&"
import style0 from "./MedicineItem.vue?vue&type=style&index=0&id=4cba47e8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cba47e8",
  null
  
)

export default component.exports